import { BellElectric, ImagePlay, ListChecks } from "lucide-react";
import CoursePageCardSubCourse from "./CoursePageCardSubCourse";

import contentMan from "./img/contentMan.svg";
const CoursePageCardSubCourseHolder =({coursePageObject})=>{
return(<>
<div className="themeCoursePage"  style={{marginTop:"50px",overflow:"hidden",
  minHeight:"190px",position:"relative"
  ,background:`${coursePageObject?.subCourseCardOuter?.bgColor?.color}`,
    border:` ${coursePageObject?.subCourseCardOuter?.border?.borderWidth?.value+coursePageObject?.subCourseCardOuter?.border?.borderWidth?.resolution} ${coursePageObject?.subCourseCardOuter?.border?.borderType}  ${coursePageObject?.subCourseCardOuter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.topLeft?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.topRight?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomLeft?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomRight?.value}${coursePageObject?.subCourseCardOuter?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:coursePageObject?.subCourseCardOuter?.iconBgColor?.color}}>
{coursePageObject?.subCourseCardOuter?.imageStatus?<img    className="CourseSideStickImgTw" src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer",
    
   }}/>:""}
</div>
<div className="themeCoursePage courseContentTitleFontTwoCoursePage coursePageHeaderFont"style={{marginBottom:"20px",color:coursePageObject?.subCourseCardOuter?.textColor?.color}}>Sub - Courses</div>
<div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",gap:"10px"}}> 
                       <div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <ListChecks strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Milestones</div>
                           </div><div style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <BellElectric strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Sections</div>
                           </div><div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCardOuter?.iconBgColor?.color}`}}> 
                         <ImagePlay strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCardOuter?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCardOuter?.subTextColor?.color}}> 5  Chapters</div>
                           </div>
                   </div>
           </div>
<div className=" " style={{marginTop:"0px"}}>

<div className="themeCoursePage gridForCoursePageFiftyFifty"  style={{marginTop:"20px",
    }}>


<CoursePageCardSubCourse coursePageObject={coursePageObject} />

<CoursePageCardSubCourse coursePageObject={coursePageObject} />

<CoursePageCardSubCourse coursePageObject={coursePageObject} />



</div>



</div>

  </div>
</>)
}
export default CoursePageCardSubCourseHolder;
